export default __webpack_public_path__ + "cc3a2763efbd084881ac68c902508c05.svg";